export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white py-10 text-slate-600">
      <div className="mx-auto grid max-w-6xl gap-6 px-6 sm:grid-cols-2">
        <div>
          <div className="text-slate-900 font-semibold">Anorc Inc</div>
          <p className="mt-2 max-w-md">Driving digital growth for small & medium businesses.</p>
          <p className="mt-3 text-sm">© {new Date().getFullYear()} Anorc Inc. All rights reserved.</p>
        </div>
        <div className="sm:text-right">
          
          <a className="block hover:text-slate-900" href="mailto:contact@anorcinc.com">contact@anorcinc.com</a>
          <a className="block hover:text-slate-900" href="tel:14374944736">1‑437-494-4736</a>
          <div className="mt-2 space-x-4">
            <a href="https://www.linkedin.com/company/anorcinc" className="hover:text-slate-900">LinkedIn</a>
            <a href="https://www.instagram.com/anorcinc/" className="hover:text-slate-900">Instagram</a>
            <a href="https://www.facebook.com/anorcinc" className="hover:text-slate-900">Facebook</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
